<template>
  <div>
    <company-add v-if="step === 0" @next="step = 1"/>
    <company-detail v-if="step === 1" @next="step = 2"/>
    <company-complete v-if="step === 2"/>
  </div>
</template>

<script>
import CompanyDetail from './detail'
import CompanyAdd from './add'
import CompanyComplete from './complete'
import {login} from '@/utils/login'

export default {
  name: "company",
  data() {
    let step = 1
    // const companyInfo = this.$store.state.companyInfo
    // if (!companyInfo) {
    //   // 新建态
    //   step = 0
    // } else {
    //   step = 1
    // }
    return {
      step
    }
  },
  created() {
    const userInfo = this.$store.state.userInfo
    if (!userInfo) {
      this.$router.push({
        name: 'home'
      })
      login()
    }else {
      this.$LogReport.sendCustomEvent('openplat_information_edit_page_load')
    }
  },
  components: {
    CompanyDetail,
    CompanyAdd,
    CompanyComplete
  }
}
</script>

<style lang="less" scoped>

</style>
